import { StateField } from "@codemirror/state"
import { Decoration, DecorationSet, EditorView } from "@codemirror/view"
import { HighlightArea } from "@components/HighlightTextArea/HighlightTextArea"

type HighlightAreaExtensionOptions = {
  areas: HighlightArea[]
  disabled: boolean
}

const HIGHLIGHT_CLASS_NAME = "cm-yaml-highlight"

export const createHighlightAreasExtension = (options: HighlightAreaExtensionOptions) => {
  const highlightField = StateField.define<DecorationSet>({
    create() {
      const areas = options.areas ?? []
      if (options.disabled || areas.length === 0) return Decoration.none

      const decorations = areas.map((area) =>
        Decoration.mark({ class: HIGHLIGHT_CLASS_NAME }).range(area.startIndex, area.endIndex),
      )
      return Decoration.set(decorations)
    },
    update: (decorations, transaction) => {
      if (options.disabled) return Decoration.none

      return decorations.map(transaction.changes)
    },
    provide: (state) => EditorView.decorations.from(state),
  })

  return [
    highlightField,
    EditorView.baseTheme({
      [`.${HIGHLIGHT_CLASS_NAME}`]: {
        backgroundColor: "rgba(190, 25, 25, 0.3)",
        borderRadius: "2px",
      },
    }),
  ]
}
